export default "__VITE_ASSET__BuIgayEH__"